import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ContractCoverPlus, SuperWifi, ContractCoverInclusions, SuperWifiInclusions, Claim, ContractCoverFaqs, SuperWifiFaqs, ContactUs } from 'src/Common/constants';
import FAQs from './FAQs';
import './ReadMore.css';

const ReadMore = ({ type }) => {

  const [state, setState] = useState({
    showClaimSubmitProcess: false,
    showInclusions: true,
    showFAQs: false,
  });

  const inclusionsArray = type === 'superWifi' ? SuperWifiInclusions : ContractCoverInclusions;
  const claimArray = type !== 'superWifi' ? Claim : [];

  const renderInclusions = (array) => (

    <div className="inclusions-card-container">

      { array.map((content, index) => (

          <div key={ index }>

            <div className="inclusions-card">
              <div className="inclusions-card-icon">{ content.icon }
                <span className="inclusions-card-topic-text">{ content.topic }</span>
              </div>

              <div className="inclusions-card-text">
                <span className="inclusions-card-description-text">
                  
                  { content.description.includes(ContactUs.claimsEmail) 
                  
                    ? <>

                        { content.description.split(ContactUs.claimsEmail)[0] }

                        <b>{ ContactUs.claimsEmail }</b>

                        { content.description.split(ContactUs.claimsEmail)[1] }

                      </>
                      
                    : content.description
                  }
                  
                </span>
                
              </div>
            </div>
            
          </div>
        ))
      }
    </div>
  );

  const toggleSection = (section) => {
    setState({
      showInclusions: section === 'showInclusions',
      showClaimSubmitProcess: section === 'showClaimSubmitProcess',
      showFAQs: section === 'showFAQs',
    });
  };

  return (

    <div className="readmore-container">

      <div className="readmore-left-container">

        <h3 className="readmore-heading">
          {
            type === 'superWifi'
              ? 'Super WiFi'
              : 'Contract Cover Plus'
          }
        </h3>

        <span className="readmore-description">
          {
            type === 'superWifi'
              ? SuperWifi
              : ContractCoverPlus
          }
        </span>

        <div className="readmore-description-link-heading">
          Important links
        </div>

        <hr />

        <div className='readmore-description-link-container'>
          <div onClick={ () => toggleSection('showInclusions') } className={(state.showInclusions)
            ? 'readmore-description-link-active'
            : 'readmore-description-link'
          }
          >
            What&apos;s included
          </div>

          {
            type !== 'superWifi' && (
              <div onClick={() => toggleSection('showClaimSubmitProcess')} className={state.showClaimSubmitProcess
                ? 'readmore-description-link-active'
                : 'readmore-description-link'}>
                How to submit claim
              </div>
            )
          }

          <div onClick={() => toggleSection('showFAQs')} className={state.showFAQs
            ? 'readmore-description-link-active'
            : 'readmore-description-link'
            }>
          
            FAQs
          </div>
          
        </div>

      </div>

      <div className="readmore-right-container">
        {
          state.showFAQs && <h3 className="readmore-right-heading">FAQs</h3>
        }
        {
          state.showInclusions && <h3 className="readmore-right-heading">What&apos;s included</h3>
        }
        {
          state.showClaimSubmitProcess && <h3 className="readmore-right-heading">How to submit a claim</h3>
        }

        {
          state.showClaimSubmitProcess && renderInclusions(claimArray)
        }
        {
          state.showInclusions && renderInclusions(inclusionsArray)
        }

        {
          type === 'superWifi' && state.showFAQs && <FAQs faq={SuperWifiFaqs} />
        }
        {
          type !== 'superWifi' && state.showFAQs && <FAQs faq={ContractCoverFaqs} />
        }
      </div>
    </div>
  );
};

ReadMore.propTypes = {
  type: PropTypes.oneOf(['superWifi', 'contractCover']).isRequired,
};

export default ReadMore;
